// src/utils/PrivateRoute.js
import React, { useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import SideBar from "../layout/SideBar";
import Header from "../layout/Header";

const PrivateRoute = ({ allowedRoles }) => {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("userRole");
  const location = useLocation();
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  if (!token) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  const handleMobileMenuToggle = () => {
    setIsMobileOpen(!isMobileOpen);
  };

  // Check if user is a nurse (no sidebar/header needed)
  const isNurse = role === "nurse";

  if (isNurse) {
    return (
      <div className="w-full h-screen overflow-auto bg-gray-50">
        <Outlet />
      </div>
    );
  }

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50">
      <SideBar
        isMobileOpen={isMobileOpen}
        setIsMobileOpen={setIsMobileOpen}
        isHovered={isHovered}
        setIsHovered={setIsHovered}
      />
      <div
        className={`flex-1 flex flex-col overflow-hidden transition-all duration-300 ${
          isHovered ? "md:ml-72" : "md:ml-28"
        }`}
      >
        {/* Mobile Header with Menu Button */}
        <div className="md:hidden">
          <Header onMobileMenuToggle={handleMobileMenuToggle} />
        </div>
        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default PrivateRoute;
